import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';

const TipEmotionalDriver = () => {
  const { t } = useTranslation();
  return (
    <Tip>
      <p>
        {t('tipEmotionalDriver')}
      </p>
    </Tip>
  );
};

export default TipEmotionalDriver;
